import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 8 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.57878 4.19256L1.29289 0.128275C0.782165 -0.20179 0 0.11851 0 0.934883V9.06151C0 9.7939 0.726806 10.2353 1.29289 9.86811L7.57878 5.80578C8.13951 5.44447 8.1413 4.55388 7.57878 4.19256Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgTriangleRight);
export default ForwardRef;
